import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
    ProductDetailViewModel,
    ProductSearchViewModelGenericSearchResultViewModel as ProductSearchResult
} from '@models/api-search.models';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    constructor(private readonly http: HttpClient) {}

    /**
     * @param productIds
     * Fetch a single or a list of products, pass comma separated ids
     * @example
     * this.getProducts('12345');
     * this.getProducts('12345', '12345');
     * this.getProducts(...myProductList);
     */
    public getProducts(...productIds: string[]): Observable<ProductSearchResult> {
        return this.http.get<ProductSearchResult>('search-ms/Product/SearchProducts', {
            params: { include: productIds }
        });
    }

    public getFilterCollection(collectionId: string, params: Params): Observable<ProductSearchResult> {
        return this.http.get<ProductSearchResult>('search-ms/Product/SearchProducts', {
            params: { collectionId, ...params }
        });
    }

    public getFilter(params: Params): Observable<ProductSearchResult> {
        return this.http.get<ProductSearchResult>(`search-ms/Product/SearchProducts`, { params });
    }

    public getProduct(productIds: string): Observable<ProductDetailViewModel> {
        return this.http.get<ProductDetailViewModel>(`search-ms/Product/GetProductDetail/${productIds}`);
    }
}
